import React, { useEffect, useState } from 'react';
import { DefaultMenuState, MenuContext } from '../../utils/contexts/contexts';
import { NavBar } from '../NavBar';
import { UnauthorizedOverlay } from './UnauthorizedOverlay';

type PageWrapperProps = {
  Content: React.ComponentType<any>;
};

export const PageWrapper = ({ Content }: PageWrapperProps) => {
  const [menuOpen, setMenuOpen] = useState(DefaultMenuState.menuOpen);
  const [showUnauthorized, setShowUnauthorized] = useState(false);

  useEffect(() => {
    const markUnauthorized = () => setShowUnauthorized(true);

    const onRejection = (e: PromiseRejectionEvent) => {
      const err = e.reason;
      if (err?.response?.status === 401 || err?.status === 401) {
        setShowUnauthorized(true);
        e.preventDefault();
      }
    };

    window.addEventListener('unauthorized', markUnauthorized);
    window.addEventListener('unhandledrejection', onRejection);
    return () => {
      window.removeEventListener('unauthorized', markUnauthorized);
      window.removeEventListener('unhandledrejection', onRejection);
    };
  }, []);

  const toggleMenuState = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <MenuContext.Provider
        value={{
          menuOpen,
          setMenuOpen,
          toggleMenuState,
        }}
    >
      { showUnauthorized && <UnauthorizedOverlay /> }

      <NavBar />
      <div className='flex min-h-screen pt-[var(--nav-height)] bg-[var(--bg-main)]'>
        <div className='flex-1 flex flex-col min-w-0 min-h-[calc(100vh-var(--nav-height))] bg-[var(--bg-main)] px-[var(--space-page-x)] py-[var(--space-page-y)] w-full'>
          <div className='flex-1 min-h-0 flex flex-col overflow-x-hidden w-full'>
            <Content />
          </div>
        </div>
      </div>
    </MenuContext.Provider>
  );
};

export default PageWrapper;
